import React from 'react';
import { groupItemsBy } from '../../services/utils';

const CONTRACT_TYPES = ['OTC', 'CME', 'Physical'];

class MarketsSection extends React.Component {

    render() {
        let { data, products, showProductInfo } = this.props;
        const productRow = item => {
            let {short_name, unit_name, contract_type} = item;
            return `${short_name} (${unit_name}, ${contract_type})`;
        }

        const groups = groupItemsBy(products, 'contract_type');

        return (
            <div>
                {CONTRACT_TYPES.map(contract_type => 
                    <div key={contract_type} className='online-market-container'>
                        {groups[contract_type] ?
                            <div className='online-market-title'>{data.name} - {contract_type}</div>
                        : null}
                        {(groups[contract_type] || []).map((item, i) => 
                            <div
                                key={'product'+data.id+'_'+item.id}
                                onClick={showProductInfo.bind(this, item, false)}
                                className='online-market-line'>
                                { productRow(item) }
                            </div>
                        )}
                    </div>
                )}
            </div>
        )
    }
}
export default MarketsSection;



// WEBPACK FOOTER //
// ./source/screens/markets/marketsSection.js